/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { PhotoResource } from './';
import {
    PhotoResourceFromJSON,
    PhotoResourceFromJSONTyped,
    PhotoResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface FreelancerOverviewResource
 */
export interface FreelancerOverviewResource {
    /**
     * 
     * @type {string}
     * @memberof FreelancerOverviewResource
     */
    accountId: string;
    /**
     * 
     * @type {string}
     * @memberof FreelancerOverviewResource
     */
    companyId: string;
    /**
     * 
     * @type {string}
     * @memberof FreelancerOverviewResource
     */
    identityId: string;
    /**
     * 
     * @type {string}
     * @memberof FreelancerOverviewResource
     */
    fullName: string;
    /**
     * 
     * @type {string}
     * @memberof FreelancerOverviewResource
     */
    title?: string;
    /**
     * 
     * @type {PhotoResource}
     * @memberof FreelancerOverviewResource
     */
    photo?: PhotoResource;
    /**
     * 
     * @type {string}
     * @memberof FreelancerOverviewResource
     */
    profileUrl?: string;
}

/**
 * Check if a given object implements the FreelancerOverviewResource interface.
 */
export function instanceOfFreelancerOverviewResource(value: object): value is FreelancerOverviewResource {
    if (!('accountId' in value) || value['accountId'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('identityId' in value) || value['identityId'] === undefined) return false;
    if (!('fullName' in value) || value['fullName'] === undefined) return false;
    return true;
}

export function FreelancerOverviewResourceFromJSON(json: any): FreelancerOverviewResource {
    return FreelancerOverviewResourceFromJSONTyped(json, false);
}

export function FreelancerOverviewResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancerOverviewResource {
    if (json == null) {
        return json;
    }
    return {
        
        'accountId': json['accountId'],
        'companyId': json['companyId'],
        'identityId': json['identityId'],
        'fullName': json['fullName'],
        'title': json['title'] == null ? undefined : json['title'],
        'photo': json['photo'] == null ? undefined : PhotoResourceFromJSON(json['photo']),
        'profileUrl': json['profileUrl'] == null ? undefined : json['profileUrl'],
    };
}

export function FreelancerOverviewResourceToJSON(value?: FreelancerOverviewResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'accountId': value['accountId'],
        'companyId': value['companyId'],
        'identityId': value['identityId'],
        'fullName': value['fullName'],
        'title': value['title'],
        'photo': PhotoResourceToJSON(value['photo']),
        'profileUrl': value['profileUrl'],
    };
}

